import React, { useState } from "react"
import { Button, Descriptions, Divider, Drawer, Image } from "antd"
import RequestStop from "./RequestStop"

const UserActionDrawer = (props) => {
  const [open, setOpen] = useState(false)

  const { data, user } = props
  const showDrawer = () => {
    setOpen(true)
  }
  const onClose = () => {
    setOpen(false)
  }
  return (
    <>
      <Button
        size="small"
        onClick={showDrawer}
        disabled={user && data && data.user !== user.email ? true : false}>
        Request
      </Button>
      <Drawer title="Order Action" placement="left" onClose={onClose} open={open}>
        <Divider>Order data</Divider>
        <Image src={data.selectedProduct.technicalPage} width={320} />
        <Descriptions column={1}>
          <Descriptions.Item label="Client">{data.client.client}</Descriptions.Item>
          <Descriptions.Item label="Product">
            {data.selectedProduct.product.productName}
          </Descriptions.Item>
        </Descriptions>
        <Divider>Actions</Divider>
        <RequestStop data={data} firstOpen={setOpen} />
      </Drawer>
    </>
  )
}
export default UserActionDrawer
